export const fromGql = (gqlItem) => ({
    url: gqlItem.url,
});
export const fromGqlCollection = (gqlItems) => gqlItems.map(fromGql);
//# sourceMappingURL=CheckoutArtistLink.js.map